// import $ from 'jquery';
import 'typeahead.js';
import Bloodhound from 'typeahead.js';
import {getConfigValue} from '../libs/@elements/config-utils'

export function initInScope($scope) {
    $scope.find('.js-places-autocomplete').each(function () {
        let minLength = 1;

        let mapboxApiBloodHoundQuery = function (q, sync, async) {
            if (q === '') {
                sync(mapboxApiBloodHound.local);
            } else {
                // console.log(mapboxApiBloodHound.search(q, sync, async));
                mapboxApiBloodHound.search(q, sync, async);
            }
        }
        let bloodHoundDefaultContainer = $(this).parents(".js-places-autocomplete-container").find(".js-places-autocomplete__defaults");
        let mapHeadline = bloodHoundDefaultContainer.data("map-headline");
        /*https://docs.mapbox.com/api/search/#endpoints*/
        var mapboxApiBloodHound = new Bloodhound({
            // local: localDogs,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            // `states` is an array of state names defined in "The Basics"
            remote: {
                url: `https://api.mapbox.com/geocoding/v5/mapbox.places/%QUERY%.json?types=country,region,postcode,address,district,place&country=AT,DE&language=${getConfigValue('lang')}&limit=5&fuzzyMatch=false&access_token=${getConfigValue('mapboxApiKey')}`,
                wildcard: '%QUERY%',
                transform: function (response) {
                    // return response.features.map(x => x['place_name']);
                    return response.features.map(feature => {
                        return { name: feature.place_name, icon: '' };
                    });
                }
            }
        });
        let typeaheadDataSets = [
            {
                name: 'places',
                display: 'name',
                source: mapboxApiBloodHoundQuery,
                templates: {
                    header: mapHeadline ? '<h5>' + mapHeadline + '</h5>' : null,
                    suggestion: function(data) {
                        // console.log("template data");
                        // console.log(data);
                        return '<div>' + data.icon + '<span>' + data.name + '</span></div>';
                    }
                },
                limit: Number.MAX_VALUE, /*workaround for https://github.com/twitter/typeahead.js/issues/1232*/
            }
        ];


        let bloodHoundDefaultOptions = bloodHoundDefaultContainer.find("span.option");
        let localDogs = [];

        if(bloodHoundDefaultOptions.length > 0) {
            minLength = 0;
            let localHeadline = bloodHoundDefaultContainer.data("local-headline");

            bloodHoundDefaultOptions.each(function () {
                localDogs.push({ name: $(this).text(), icon: '<i class="icon icon-poi-outline"></i>' });
            });
            let localDogsBloodHoundQuery = function (q, sync, async) {
                if (q === '') {
                    sync(localDogsBloodHound.local);
                } else {
                    // console.log(mapboxApiBloodHound.search(q, sync, async));
                    localDogsBloodHound.search(q, sync, async);
                }
            }

            var localDogsBloodHound = new Bloodhound({
                local: localDogs,
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                queryTokenizer: Bloodhound.tokenizers.whitespace
            });

            if(localDogs.length > 0) {
                typeaheadDataSets.unshift({
                    name: 'places',
                    display: 'name',
                    source: localDogsBloodHoundQuery,
                    templates: {
                        header: '<h5>' + localHeadline + '</h5>',
                        suggestion: function(data) {
                            // console.log("template data");
                            // console.log(data);
                            return '<div>' + data.icon + '<span>' + data.name + '</span></div>';
                        }
                    },
                    limit: Number.MAX_VALUE, /*workaround for https://github.com/twitter/typeahead.js/issues/1232*/
                });
            }
        }

        $(this).typeahead({
            hint: true,
            highlight: true,
            minLength: minLength
        }, typeaheadDataSets);
    });

}